/** @jsx jsx */
import { createContext } from 'react';
import { css, jsx } from '@emotion/react';
import { gapMediaQueries, inlinePaddingMediaQueries } from './grid-media-querys';
var containerBaseStyles = css({
  display: 'grid',
  boxSizing: 'border-box',
  width: '100%',
  gridTemplateColumns: "1fr",
  marginInline: 'auto'
});
var gridMaxWidthMap = {
  wide: css({
    maxWidth: '70.5rem'
  }),
  narrow: css({
    maxWidth: '46.5rem'
  })
};

/**
 * __Grid container context__
 *
 * A grid container context used to detect to detect wether a component is inside a grid container.
 *
 */
export var GridContainerContext = /*#__PURE__*/createContext(false);

/**
 * __GridContainer__
 *
 * A grid container is a grid with one column whith the purpose of stacking grids on top of each other
 * while maintaining the responsive gaps between grids
 * - [Code](https://atlassian.design/components/grid-container)
 *
 * @example
 * ```jsx
 * import Grid, { GridItem, GridContainer } from '@atlaskit/grid';
 *
 * const App = () => (
 *  <GridContainer>
 *    <Grid>
 *      <GridItem></GridItem>
 *    </Grid>
 *    <Grid>
 *      <GridItem></GridItem>
 *    </Grid>
 *  <GridContainer>
 * );
 * ```
 */
export var GridContainer = function GridContainer(_ref) {
  var testId = _ref.testId,
    children = _ref.children,
    maxWidth = _ref.maxWidth,
    _ref$hasInlinePadding = _ref.hasInlinePadding,
    hasInlinePadding = _ref$hasInlinePadding === void 0 ? true : _ref$hasInlinePadding;
  return jsx("div", {
    "data-testid": testId,
    css: [containerBaseStyles,
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    gapMediaQueries, maxWidth && gridMaxWidthMap[maxWidth],
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    hasInlinePadding && inlinePaddingMediaQueries]
  }, jsx(GridContainerContext.Provider, {
    value: true
  }, children));
};